import {
    REFEREES_FAILURE,
    REFEREES_REQUEST,
    REFEREES_SUCCESS,
    REFEREE_POST_SUCCESS,
    REFEREE_DELETE_SUCCESS,
    REFEREE_PATCH_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export default (state = initialState, action) => {
    const { type, data, referee } = action;
    switch (type) {
        case REFEREE_DELETE_SUCCESS: {
            const newData = state.data.filter(d => d.id !== referee)
            return {
                ...state,
                data: [...newData]
            }
        }

        case REFEREE_PATCH_SUCCESS: {
            return {
                ...state,
                data: state.data.map(d => d.id === referee.id ? referee : d)
            }
        }

        case REFEREE_POST_SUCCESS: {
            return {
                ...state,
                data: [...state.data, referee]
            }
        }

        case REFEREES_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case REFEREES_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case REFEREES_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
